var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BrToolBar',{attrs:{"configFilter":_vm.configFilter,"addlFilter":_vm.addlFilter,"labelTextField":_vm.labelTextField},on:{"search":_vm.buscar}},[_c('BrModalCadastro')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }